/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrizePublic
 */
export interface PrizePublic {
    /**
     * The unique identifier of the prize
     * @type {string}
     * @memberof PrizePublic
     */
    prizeId: string;
    /**
     * The name of the prize
     * @type {string}
     * @memberof PrizePublic
     */
    name: string;
    /**
     * Description of the prize
     * @type {string}
     * @memberof PrizePublic
     */
    description?: string;
    /**
     * Weight for random selection (higher = more likely)
     * @type {number}
     * @memberof PrizePublic
     */
    weight: number;
    /**
     * Sanitized metadata (excludes sensitive URLs)
     * @type {{ [key: string]: any; }}
     * @memberof PrizePublic
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the PrizePublic interface.
 */
export function instanceOfPrizePublic(value: object): value is PrizePublic {
    let isInstance = true;
    isInstance = isInstance && "prizeId" in value && value["prizeId"] !== undefined;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;
    isInstance = isInstance && "weight" in value && value["weight"] !== undefined;

    return isInstance;
}

export function PrizePublicFromJSON(json: any): PrizePublic {
    return PrizePublicFromJSONTyped(json, false);
}

export function PrizePublicFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizePublic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prizeId': json['prize_id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'weight': json['weight'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
    };
}

export function PrizePublicToJSON(value?: PrizePublic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prize_id': value.prizeId,
        'name': value.name,
        'description': value.description,
        'weight': value.weight,
        'metadata': value.metadata,
    };
}

